import { createRouter, createWebHashHistory } from "vue-router";

import Home from "./views/home-page";
import Profile from "./views/profile-page";
import Tasks from "./views/tasks-page";
import defaultLayout from "./layouts/side-nav-outer-toolbar";
import simpleLayout from "./layouts/single-card";
import cetakLayout from "./layouts/cetak-layout.vue";
import { useAppStore } from "./stores/app-store";

function loadView(view) {
  return () => import(/* webpackChunkName: "login" */ `./views/${view}.vue`)
}


function loadCetakView(view) {
  return () => import(/* webpackChunkName: "login" */ `./views/cetak/${view}.vue`)
}

function createRoute(name, path) {
  if(!path) {
    path = `/${name}`;
  }
  return {
    path,
    name,
    meta: {
      requiresAuth: true,
      layout: defaultLayout,
    },
    component: loadView(name + "-page")
  }
}

function createRouteCetak(name) {
  return {
    path: `/${name}/cetak/:id`,
    name: `cetak-${name}`,
    meta: {
      requiresAuth: true,
      layout: cetakLayout,
    },
    component: loadCetakView(name + '-cetak')
  }
}

const router = new createRouter({
  routes: [
    {
      path: "/home",
      name: "home",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Home
    },
    createRoute('pengguna', '/pengguna'),
    createRoute('jabatan', '/jabatan'),
    createRoute('setting', '/setting'),
    createRoute('barang', '/barang'),
    createRoute('foto_barang', '/foto_barang'),
    createRoute('brand', '/brand'),
    createRoute('bank', '/bank'),
    createRoute('giro', '/giro'),
    createRoute('cara-bayar', '/cara_bayar'),
    createRoute('gudang', '/gudang'),
    createRoute('jenis-barang', '/jenis_barang'),
    createRoute('jenis-dokumen-outlet', '/jenis_dokumen_outlet'),
    createRoute('jenis-harga-jual', '/jenis_harga_jual'),
    createRoute('kategori-barang', '/kategori_barang'),
    createRoute('rak', '/rak'),
    createRoute('jenis-pengenal', '/jenis_pengenal'),
    createRoute('sales', '/sales'),
    createRoute('outlet', '/outlet'),
    createRoute('dokumen_outlet', '/dokumen_outlet'),
    createRoute('status-bayar', '/status_bayar'),
    createRoute('status-pesanan', '/status_pesanan'),
    createRoute('tipe-outlet', '/tipe_outlet'),
    createRoute('tipe-kunjungan', '/tipe_kunjungan'),
    createRoute('jual', '/jual'),
    createRouteCetak('jual'),
    createRoute('piutang', '/piutang'),
    createRoute('bayar_piutang', '/bayar_piutang'),
    createRoute('jenis-absen', '/jenis_absen'),
    createRoute('sales-order', '/sales_order'),
    createRouteCetak('sales-order'),
    createRoute('provinsi', '/provinsi'),
    createRoute('kota', '/kota'),
    createRoute('kelurahan', '/kelurahan'),
    createRoute('kecamatan', '/kecamatan'),
    createRoute('kategori_akun', '/kategori_akun'),
    createRoute('akun', '/akun'),
    createRoute('supplier', '/supplier'),
    createRoute('import_barang'),
    createRoute('import_outlet'),
    createRoute('import_stok'),
    createRoute('import_foto_barang'),
    createRoute('import_dokumen_outlet'),
    createRoute('absen_sales'),
    {
      path: "/profile",
      name: "profile",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Profile
    },
    {
      path: "/tasks",
      name: "tasks",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Tasks
    },
    {
      path: "/login-form",
      name: "login-form",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Sign In"
      },
      component: loadView("login-form")
    },
    {
      path: "/no_akses",
      name: "no_akses",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Sign In"
      },
      component: loadView("no-akses-page")
    },
    {
      path: "/reset-password",
      name: "reset-password",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Reset Password",
        description: "Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
      },
      component: loadView("reset-password-form")
    },
    {
      path: "/create-account",
      name: "create-account",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Sign Up"
      },
      component: loadView("create-account-form"),
    },
    {
      path: "/change-password/:recoveryCode",
      name: "change-password",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Change Password"
      },
      component: loadView("change-password-form")
    },
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/recovery",
      redirect: "/home"
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/home"
    }
  ],
  history: createWebHashHistory()
});

router.beforeEach((to, from, next) => {
  const store = useAppStore();
  let isLogin = store.isLogin;
  if (to.name === "login-form" && isLogin) {
    next({ name: "home" });
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLogin) {
      next({
        name: "login-form",
        query: { redirect: to.fullPath }
      });
    } else {
      console.info('to.path', to.path);
      if(to.path == '/' || to.name == 'home') {
        return next();
      }
      // check if user has access to the route
      let kiri = to.path.replace(/^\//, '');
      let boleh = store.boleh(kiri + ':lihat')
      console.info('boleh', boleh);
      if(boleh) {
        next();
      } else {
        next({
          name: "login-form",
          query: { redirect: to.fullPath }
        });
      }
    }
  } else {
    next();
  }
});


export default router;
